import { canUseDOM } from '@ps/web-core-utils';

const getWindow = () => (canUseDOM ? window : undefined);

export default getWindow;
